export const FixIDS = {

  Role: { List: 1, Add: 2, Update: 3, Delete: 4 },
  Owner: { List: 5, Add: 6, Update: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Update: 11, Delete: 12 },
  State: { List: 13, Add: 14, Update: 15, Delete: 16 },
  City: { List: 17, Add: 18, Update: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Update: 23, Delete: 24 },
  Tenant: { List: 25, Add: 26, Update: 27, Delete: 28 },
  Property: { List: 29, Add: 30, Update: 31, Delete: 32 },
  AssignTenant: { List: 33, Add: 34, Update: 35, Delete: 36 },
  Dashboard: { OwnerCount: 37, TenantCount: 38, PropertyCount: 39, MyPropertyCount: 40, MyTenantCount: 49 },
  Subscription: { List: 41, Add: 42, Update: 43, Delete: 44, History: 45, Buy: 46 },
  Payment: { History: 47 },
  Settings: 48,

};

export const usersIDS = {
  admin: 1,
  Owner: 2,
  Tenant: 3,
};

export const orderStatus = {
  OrderPlaced: 1,
  CancelOrder: 2,
  PaymentConfirmation: 3,
  // ProductAvailability: 3,
  OrderReceived: 4,
  DesignDetailsCollection: 5,
  DesignCreation: 6,
  CustomerApproval: 7,
  PrintingProcess: 8,
  QualityCheck: 9,
  Finishing: 10,
  Packing: 11,
  LabellingShipping: 12,
  FinalDelivery: 13,

  Delivered: 15,
};
